import Vue from 'vue';
import Component from 'vue-class-component';
import * as i18next from 'i18next';
import router from 'src/router';
import * as auth from 'core/auth';
import * as api from 'core/api';
import { UserState } from 'core/store/modules/user';
import { FETCH_USER_COUPONS } from 'core/store/action-types';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

export interface AccountComponentModel {
    state: string;
    user: api.User | null;
}

@WithRender
@Component
export default class AccountComponent extends Vue {
    $auth: auth.AuthService; // Injected in G2S.init

    get userCoupons(): api.CouponListModel[] | undefined {
        return (<UserState>this.$store.state.user).coupons;
    }

    model: AccountComponentModel = {
        state: 'loading',
        user: null
    }

    mounted() {
        window.document.title = i18next.t('title_account');

        if (this.$auth.authenticated) {
            this.loadModel();
        } else {
            this.$nextTick(function () {
                if (this.$route.query.token) {
                    // If token in url the try to confirm user
                    this.$auth.confirm(this.$route.query.token as string).then(
                        (user: api.User) => {
                            if (user.hasPassword) {
                                window.location.href = '/account';
                            }
                            else {
                                window.location.href = '/account/welcome/password';
                            }
                        },
                        () => {
                            window.location.href = '/account';
                        }
                    );
                } else {
                    router.push('/signin');
                }
            });
        }
    }

    loadModel() {
        this.model.state = 'loading';

        const getCurrentUserPromise = this.$auth.getCurrentUser()
            .then((result: api.User) => {
                if (result.hasPassword) {
                    this.model.user = result;
                }
                else {
                    router.push('/account/welcome/password');
                }
            }).catch(() => {
                router.push('/signin');

                return 'error';
            });
        let fetchUserCouponsPromise;

        if (this.userCoupons == null) {
            fetchUserCouponsPromise = this.$store.dispatch(FETCH_USER_COUPONS)
                .catch(() => {
                    return 'error';
                });
        } else {
            fetchUserCouponsPromise = Promise.resolve();
        }

        Promise.all([getCurrentUserPromise, fetchUserCouponsPromise])
            .then((result) => {
                if (result[0] == 'error') {
                    this.model.state = 'error';
                } else {
                    this.model.state = 'view';
                }
            });
    }

    onSignOut() {
        this.$auth.signOut().then(
            (response: boolean) => {
                (<any>this).$ga.sendEvent('signout', 'success', 'signout.success');

                location.href = '/';
            },
            (error) => {
                (<any>this.$root.$refs).messageDialog.show({
                    message: error?.response?.data?.localizedMessage ? error.response.data.localizedMessage : i18next.t('error_server_tryagain')
                });

                if (error.response) {
                    console.log('XHR failed', error.response.status, error.response.data);
                } else {
                    console.log('XHR error', error.message);
                }
            }
        );
        
    }
}
